import { connect, ConnectedProps } from 'react-redux'
import InputTableLeftColumn, { InputTableLeftColumnCompleteRequiredProps } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn'
import withLoading from '../../../../../../../../../../utils/hoc/withLoading'
import { ComponentTabObject } from '../../../../../../../../../../utils/hooks/useTabLogic'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../../../../utils/reducers/company/workingCenters'
import QuoteStepHeaderMain, { useQuoteStepHeaderMainLogic } from '../../../../../header/QuoteStepHeaderMain'
import QuoteStepHeaderShipping from '../../../../../header/QuoteStepHeaderShipping'
import QuoteStepHeaderFinancialRows from '../../../../../header/QuoteStepHeaderFinancialRows'
import QuoteStepHeaderCosts from '../../../../../header/QuoteStepHeaderCosts'
import { CostSellPayload } from '../../../../../../../../../../utils/reducers/company/costsSell'
import useQuoteOrderHeaderUrls from '../../../../../../../../../../utils/hooks/quotes/useQuoteOrderHeaderUrls'
import QuoteStepHeaderAccounts from '../../../../../header/QuoteStepHeaderAccounts'
import { SellTagsPayload } from '../../../../../../../../../../utils/reducers/sells/sellTags'
import QuoteStepHeaderVariables from '../../../../../header/QuoteStepHeaderVariables'
import { EmployeesPayload } from '../../../../../../../../../../utils/reducers/company/employees'
import { SellVariablePayload } from '../../../../../../../../../../utils/reducers/company/sellVariable'
import { Fragment } from 'react'
import InputTableTopHeader from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableTopHeader'
import { useOrderITHeaderHandleChangeLogic } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/useOrderITHeaderHandleChange'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { FormElement, FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { QuoteOrderModelType } from '@teinor/erp/types/company/order/quote/quoteOrder'
import ITHeaderText from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import { sortEmployeesByUser } from '../../../../../../../../../../utils/globals/employees'
import { InputWithLabelMargin } from '../../../../../../../../../../forms/Input'
import { returnClassOfSpanTemplate } from '../../../../../../../../../../utils/globals/tailwind'
import { CustomSellSelectCampaign, CustomSellSelectProject } from '../../../../../../../../../../specificComponents/sells/components'
import { ITHeaderOrderTagsNew } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components'
import { notHaveCountersWorkingCenter } from '../../../../../../../../../../utils/globals/order/order'
import { CustomSelectWithSearchBar } from '../../../../../../../../../../forms/CustomSelect'
import ModalEditOrderCurrency from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalEditOrderCurrency'
import { ProductTypesPayload } from '../../../../../../../../../../utils/reducers/products/productTypes'

type QuoteOrderCreateStepITHeaderProps = InputTableLeftColumnCompleteRequiredProps & ReduxQuoteOrderCreateStepITHeader & {}

const QuoteOrderCreateStepITHeader: React.FC<QuoteOrderCreateStepITHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={QuoteOrderCreateStepITHeaderDefault} NewComponent={QuoteOrderCreateStepITHeaderNew} {...rest} />
    )
}

const QuoteOrderCreateStepITHeaderDefault: React.FC<QuoteOrderCreateStepITHeaderProps> = ({ workingCenters, employees, sellTags, ...rest }) => {
    const { t } = useTwinTranslation()
    const orderHeaderURLs = useQuoteOrderHeaderUrls()
    const tabs: ComponentTabObject = {
        'main': {
            component: QuoteStepHeaderMain,
            text: t('dataQuote', 'Datos del presupuesto'),
            extraProps: { workingCenters, employees, sellTags: sellTags?.allTags, orderHeaderURLs, updateCurrencyURL: '/api/app/order/quote/updateQuoteOrderCurrency' }
        },
        'discounts': {
            component: QuoteStepHeaderFinancialRows,
            text: t('discountsAndRecharges', 'Descuentos y recargos'),
            permission: 'quote.order',
            extraProps: { orderHeaderURLs }
        },
        'costs': {
            component: QuoteStepHeaderCosts,
            text: t('costsQuote', 'Gastos del presupuesto'),
            permission: 'quote.order',
            extraProps: { orderHeaderURLs }
        },
        'shipping': {
            component: QuoteStepHeaderShipping,
            text: t('shipping', 'Transporte'),
            permission: 'quote.order',
            extraProps: { orderHeaderURLs }
        },
        'accounts': {
            component: QuoteStepHeaderAccounts,
            text: t('divideIntoChapters', 'Dividir en capítulos'),
            permission: 'quote.order',
            extraProps: { orderHeaderURLs }
        },
        'variables': {
            component: QuoteStepHeaderVariables,
            text: t('quoteVariables', 'Variables del presupuesto'),
            permission: 'quote.order',
            extraProps: { orderHeaderURLs }
        },
    }
    return (
        <InputTableLeftColumn tabs={tabs} {...rest} />
    )
}

const QuoteOrderCreateStepITHeaderNew: React.FC<QuoteOrderCreateStepITHeaderProps> = ({ workingCenters, employees, sellTags, getCompleteData, ...rest }) => {
    const { t } = useTwinTranslation()
    const headerData = rest?.headerData
    const { dictQuoteStepHeaderExtraData, activeCurrencies, openModal, setOpenModal, changeCurrencyId, memorizedWorkingCenters, workingCenterAddress, getCustomerCampaigns, getCustomerProjects, customerProjects, customerCampaigns, dictWarehouses } = useQuoteStepHeaderMainLogic({ headerData: headerData || {}, workingCenters  })
    const { handleChange } = useOrderITHeaderHandleChangeLogic({ setCompleteData: rest?.setCompleteData, updateDataURL: rest?.updateDataURL })
    let extraFields: FormElement<keyof QuoteOrderModelType>[] = []
    if (headerData?.CustomerAddressId) {
        extraFields.push({
            name: 'CustomerAddressId',
            component: 'Custom',
            render: () => {
                return <ITHeaderText label={t('fiscalAddress', 'Dirección Fiscal')} value={dictQuoteStepHeaderExtraData?.CustomerAddress || ''} />
            },
            hideSectionByDefault: true
        })
    }
    const sections: FormRender<QuoteOrderModelType> = [
        {
            cols: 7,
            className: 'gap-x-20',
            elements: [
                {
                    name: 'full_assigned_number',
                    component: 'Custom',
                    render: ({ value }) => <ITHeaderText label={t('quoteN', 'Nº presupuesto')} value={value} className={(headerData?.assigned_number ? '' : 'text-red-BA')} />,
                    hideSectionByDefault: true
                },
                {
                    name: 'processed_date',
                    component: 'InputCalendarStateFull',
                    label: t('date', 'Fecha'),
                    onlyValids: true,
                    required: true
                },
                {
                    name: 'RepresentativeEmployeeId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('representative', 'Representante'),
                    items: employees || {},
                    sortItems: true,
                    fieldName: 'fullname_short',
                    sortFunction: (emp) => sortEmployeesByUser(emp, false)
                },
                {
                    name: 'custom_name',
                    component: 'Custom',
                    render: (props) => {
                        return <InputWithLabelMargin name='custom_name' label={t('customName', 'Nombre personalizado')} onChange={props.onChange} defaultValue={headerData?.custom_name || ''} className='custom_name_input_field' />
                    }
                },
                {
                    name: 'CustomerProjectId',
                    component: 'Custom',
                    render: ({ extraProps, setLockOnClickOut }) => <CustomSellSelectProject getCompleteData={getCustomerProjects} handleChange={handleChange} headerData={headerData || {}} items={extraProps.customerProjects} orderByOpp={true} setLockOnClickOut={setLockOnClickOut} />,
                    extraProps: {
                        customerProjects: customerProjects || {}
                    }
                },
                {
                    name: 'CampaignCustomerId',
                    component: 'Custom',
                    render: ({ extraProps, setLockOnClickOut }) => <CustomSellSelectCampaign getCompleteData={getCustomerCampaigns} handleChange={handleChange} headerData={headerData || {}} items={extraProps.customerCampaigns} label={t('campaign', 'Campaña')} setLockOnClickOut={setLockOnClickOut} />,
                    extraProps: {
                        customerCampaigns: customerCampaigns || {}
                    },
                    hideSectionByDefault: true
                },
                {
                    name: 'OrderTags',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return (
                            <ITHeaderOrderTagsNew getCompleteData={getCompleteData} dictTags={extraProps?.dictTags || []} className={returnClassOfSpanTemplate(3) + ' order_top_header_custom_select_tags'} selectedTags={extraProps.selectedTags} onChange={handleChange} headerData={headerData || {}} />)
                    },
                    extraProps: {
                        selectedTags: headerData?.tags,
                        dictTags: sellTags?.allTags
                    }
                },
                {
                    name: 'WorkingCenterAddressId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('workingCenterFiscalAddress', 'Dirección Fiscal centro de trabajo')} value={workingCenterAddress || ''} />
                    },
                    hideSectionByDefault: true
                },
                ...extraFields,
                {
                    name: 'WorkingCenterId',
                    component: 'CustomSelectBlockedItemsSearchbar',
                    label: t('workingCenter', 'Centro de trabajo'),
                    items: memorizedWorkingCenters || {},
                    blockItemsFnc: notHaveCountersWorkingCenter,
                    sortItems: true,
                    hideSectionByDefault: true
                },
                {
                    name: 'WarehouseId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('warehouse', 'Almacén'),
                    items: dictWarehouses || {},
                    className: returnClassOfSpanTemplate(5),
                    value: headerData?.WarehouseId || 0,
                    hideSectionByDefault: true
                },
                {
                    name: 'CurrencyId',
                    component: 'Custom',
                    render: ({ extraProps }) => {
                        return <CustomSelectWithSearchBar label={t('currency', 'Moneda')} items={extraProps.activeCurrencies} value={extraProps.CurrencyId} onChange={extraProps.changeCurrencyId} className={returnClassOfSpanTemplate(2)} isStateLess={true} />
                    },
                    hideSectionByDefault: true,
                    extraProps: {
                        activeCurrencies,
                        CurrencyId: headerData?.CurrencyId,
                        changeCurrencyId
                    }
                },
                {
                    name: 'WorkingCenterCounterId',
                    component: 'Custom',
                    render: () => {
                        return <ITHeaderText label={t('serie', 'Serie')} value={headerData?.WorkingCenterCounter?.serie} />
                    },
                    hideSectionByDefault: true
                }
            ]
        }
    ]

    return (
        <Fragment>
            <InputTableTopHeader handleChange={handleChange} sections={sections} headerData={headerData} getCompleteData={getCompleteData} />
            {openModal?.type === 'edit' ?
                <ModalEditOrderCurrency Currency={activeCurrencies?.[openModal?.allRowData?.CurrencyId]?.name} id={headerData?.id} {...{ updateCurrencyURL: '/api/app/order/quote/updateQuoteOrderCurrency', onSubmit: getCompleteData, setOpened: () => setOpenModal(null), allRowData: openModal?.allRowData }} />
                : null
            }
        </Fragment>
    )
}

const quoteOrderCreateStepHeaderDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setCostsSell: (payload: CostSellPayload) => ({ type: 'CHANGE_COSTSELL', payload }),
    setSellTags: (payload: SellTagsPayload) => ({ type: 'CHANGE_SELL_TAGS', payload }),
    setSellVariables: (payload: SellVariablePayload) => ({ type: 'CHANGE_SELLVARIABLE', payload }),
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
    setProductTypes: (payload: ProductTypesPayload) => ({ type: 'CHANGE_PRODUCT_TYPES', payload }),
}

export type ReduxQuoteOrderCreateStepITHeader = ConnectedProps<typeof quoteOrderCreateStepHeaderConnect>
const mapQuoteOrderCreateStepITHeaderConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, costsSell: state.costsSell, sellTags: state.sellTags, employees: state.employees, sellVariables: state.sellVariables, productTypes: state.productTypes })
const quoteOrderCreateStepHeaderConnect = connect(mapQuoteOrderCreateStepITHeaderConnector, quoteOrderCreateStepHeaderDispatch)
const quoteOrderCreateStepHeaderConnectLoading = withLoading(QuoteOrderCreateStepITHeader, [{ fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }, { fetchUrl: '/api/app/config/cost/costSell/getAllCostSells', propName: 'costsSell', setFunctionName: 'setCostsSell' }, { fetchUrl: '/api/app/order/sell/sellTag/getAllSellTags', propName: 'sellTags', setFunctionName: 'setSellTags' }, { fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }, { fetchUrl: '/api/app/config/sell/sellVariable/getAllSellVariables', propName: 'sellVariables', setFunctionName: 'setSellVariables' }, { fetchUrl: '/api/app/product/productType/getAllProductTypes', propName: 'productTypes', setFunctionName: 'setProductTypes' } ])
const QuoteOrderCreateStepITHeaderConnect = quoteOrderCreateStepHeaderConnect(quoteOrderCreateStepHeaderConnectLoading)

export default QuoteOrderCreateStepITHeaderConnect